export const APP_VERSION_STRING = "0.10.0";
